import { SyncLogicConfigurationT } from "../../types/ISyncLogic";

export function getSyncLogicSyncConfiguration(config: {
  isFirstSync: boolean;
  isRecoverySync: boolean;
}): SyncLogicConfigurationT | undefined {
  if (config.isFirstSync || config.isRecoverySync) {
    return {
      includeDone: "false",
      includeDeleted: "false",
    };
  }

  return undefined;
}
